import { MB_DISPLAY_TYPE } from "../constants/mbDisplayType";

/**
 * スタンプラリー表示タイプかどうかを返す
 * @param {string | undefined | null} mbDisplayType
 * @returns {boolean}
 */
export const checkIsStampRally = (mbDisplayType) => {
  return (
    mbDisplayType === MB_DISPLAY_TYPE.STAMP_CARD ||
    mbDisplayType === MB_DISPLAY_TYPE.STAMP_RALLY
  );
};
